// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"194":"8d23dcb1","477":"653102e4","789":"17bd8f02","928":"9da4b153"}[chunkId] + ".css";
};